/* eslint-disable */
export class ForgotPasswordRequest {
    email!: string | undefined;

    constructor(obj?: any) {
        if (!obj) {
            return;
        }
        this.email = obj.email;
       
    }
}